module.exports = __webpack_public_path__ + "static/media/s3.6e7595aa.jpg";